exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".error{height:calc(100% - 50px);position:relative;padding-top:50px}.error .content{padding:25px;margin:25px;border-radius:10px;background-color:hsla(0,0%,100%,.7)}.error .content .image{text-align:center}.error .content .image img{width:100px}.error .content .title{font-weight:700;margin-bottom:20px;font-size:16px}.error .content .note{font-size:16px}.error .support{position:absolute;bottom:0;width:100%;text-align:center;color:#fff;background-color:rgba(0,0,0,.7);padding:10px 0;font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-764b8ca6","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/login/Error.vue
// module id = 401
// module chunks = 1